module.exports = __webpack_public_path__ + "img/contact_map@2x.d25f1e7e.png";